import "./PrivacyPolicy.module.css";
import Header from "@/reusable_sections/Header";
import PrivacyPolicyOverview from "./sections/PrivacyPolicyOverview";
import LegalBasis from "./sections/LegalBasis";
import DataRetention from "./sections/DataRetention";
import DataSharing from "./sections/DataSharing";
import UserRights from "./sections/UserRights";
import Jurisdiction from "./sections/Jurisdiction";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPolicyPage() {
  return <div>
      <Header />
      <PrivacyPolicyOverview />
      <LegalBasis />
      <DataRetention />
      <DataSharing />
      <UserRights />
      <Jurisdiction />
      <Footer />
    </div>;
}